/** Initiales d'un nom : premier et dernier mot (« Marie de La Tour » → « MT »), sinon ses deux premières lettres. */
export function initiales(nom: string): string {
  const mots = nom.trim().split(/\s+/).filter((m) => m.length > 0)
  if (mots.length >= 2) return (mots[0][0] + mots[mots.length - 1][0]).toUpperCase()
  return nom.trim().slice(0, 2).toUpperCase()
}
